import { useEffect, useState } from "react";
import { AdminService } from "../../../core/services/AdminService";
import { Singleton } from "../../../core/services/Singleton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { DataBeanProperties, ObjectValue } from '../../../core/services/model/server-response.interface';

interface Props{
    idDocumentTemplate:number
}
export const DictionaryPropertyes=({idDocumentTemplate}:Props)=>{

    const single = Singleton.getInstance();
    const service = new AdminService();
    const [bean,setBean] = useState<any>({});

    const [lista,setLista] = useState<any>([]);

    
    useEffect(()=>{
        DictionaryPropertyes();
    },[idDocumentTemplate])

    const DictionaryPropertyes=()=>{
        single.spinner(true);
        service.getProperties(idDocumentTemplate).subscribe(
            (resp:any)=>{
               //console.log(resp);
                
                if(resp.DataBeanProperties.ObjectValue)
                {
                    let list = resp.DataBeanProperties.ObjectValue;
                    
                    setLista(list);
                }
                else{
                    setLista([]);
                }
                single.spinner(false);
            }
        )
    }

    const head = [
        {title:'Campo',property:'PropertyName',visible:true},
        {title:'Nombre Propiedad',property:'PropertyTag',visible:true},
        
    ]

    return(
        <div className="row">
            <div className="col">
                <BasicTable body={lista} head={head} rowSet={setBean}></BasicTable>
            </div>
        </div>
    )
}